module.exports = __webpack_public_path__ + "I5U1-lightgray.png?f389b777bc33f68d631e059d4acb3dff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/I5U1-lightgray.png
// module id = 98
// module chunks = 0